import React, {useState, useCallback} from "react"
import styled from '@emotion/styled'
import {StaticQuery, graphql} from 'gatsby'

import Button from './Button'
import AnchorButton from './AnchorButton'

const Container = styled.section`
`

const openMailTo = (contact, form) => {
  const extractFormValue = (name, defaultValue='<Unknown>') => {
    const input = form.elements[name]
    return input ? input.value : defaultValue
  }
  const email = encodeURI(contact.email)
  const name = extractFormValue('name')
  const message = extractFormValue('message')
  const subject = encodeURIComponent(`${contact.subject} - ${name}`)
  const body = encodeURIComponent(`${contact.body}\n\n${message}`)
  window.open(
    `mailto:${email}?subject=${subject}&body=${body}`,
    '_self')
}

const Form = styled.form`
  display: flex;
  flex-direction: column;

  > label {
    margin-bottom: 1rem;

    > input,
    > textarea {
      font-size: 14px;
      background: none;
      border: none;
      border-bottom: 2px solid rgba(145, 183, 204, 0.5);
      width: 100%;

      &:required {
        box-shadow: none
      }

      &::placeholder {
        color: #373f3d;
      }
    }
  }
`

const ContactForm = ({contact, onSubmitted}) => {
  const onFormSubmit = useCallback(evt => {
    evt.preventDefault()
    evt.stopPropagation()
    openMailTo(contact, evt.target)
    onSubmitted(true)
  })
  return (
    <>
      <p>Leave a message or enquiry below and we'll get back to you promptly.</p>
      <Form method="GET" onSubmit={onFormSubmit}>
        <label>
          <input
            required={true}
            placeholder="Name…"
            name="name"
            type="text" />
        </label>
        <label>
          <textarea
            rows="5"
            required={true}
            placeholder="Enquiry…"
            name="message"
            type="text" />
        </label>
        <div style={{marginTop: '2rem', alignSelf: 'flex-start'}}>
          <Button>Send message</Button>
        </div>
      </Form>
    </>
  )
}

const SubmitComplete = styled.p`
`

const ContactComponent = ({style, contact}) => {
  const [hasSubmitted, setHasSubmitted] = useState(false)
  return (
    <Container style={style}>
      <h1>Reach Out</h1>
      {
        hasSubmitted
        ? <SubmitComplete>{contact.completeMessage}</SubmitComplete>
        : <ContactForm contact={contact} onSubmitted={setHasSubmitted} />
      }
    </Container>
  )
}

const Contact = ({style}) => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            contact {
              email
              subject
              body
              completeMessage
            }
          }
        }
      }
    `}
    render={data => <ContactComponent style={style} contact={data.site.siteMetadata.contact} />}
  />
)

export default Contact
